import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        fieldTitle: {
            marginTop: theme.spacing(1),
            textAlign: 'left',
            fontSize: 10,
            color: theme.palette.secondary[700],
            opacity: 1,
        },
        textFieldText: {
            color: `${theme.palette.secondary[900]} !important`,
        },
        requiredMark: {
            position: 'absolute',
            left: 9,
            width: 4,
            height: 27,
            backgroundColor: theme.palette.primary.main,
            borderRadius: 3,
        },
        isRequired: {
            backgroundColor: theme.palette.primary[30],
        },
        disabled: {
            textFillColor: `${theme.palette.secondary[900]} !important`,
        },
    }
})

export default useStyles
